module.exports = __webpack_public_path__ + "img/hermitage.c1274cc3.png";